import { css } from '@emotion/react';
import { Badge, Button, Heading, Text } from '@ownhealthil/wound-ui';

import Logo from 'images/wound_logo.png';
import LoginImage from 'images/login_image.png';
import theme from 'styles/theme';

const pageCss = css`
  display: flex;
  height: 100vh;
  overflow: hidden;

  @media (max-width: ${theme.breakpoints.values.xs}px) {
    flex-direction: column;
  }
`;

const leftPanelCss = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 48px 80px;
  background-color: var(--white);

  @media (max-width: ${theme.breakpoints.values.xs}px) {
    padding: 32px 40px;
    flex: none;
  }
`;

const logoCss = css`
  width: 170px;
  display: block;
`;

const contentCss = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 450px;
  gap: 48px;
`;

const badgeWrapperCss = css`
  height: 2.3rem;
  font-size: 0.875rem;
  padding-inline: 20px;
  font-weight: 500;
  margin-bottom: 20px;

  .HioBadge__text {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

const bodyTextCss = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const titleCss = css`
  margin: 0 0 16px;
  text-wrap: balance;
`;

const rightPanelCss = css`
  flex: 2.5;
  background:
    center / cover no-repeat url(${LoginImage}),
    var(--teal-400);

  @media (max-width: ${theme.breakpoints.values.xs}px) {
    flex: none;
    height: 240px;
    order: -1;
  }
`;

function MaintenancePage() {
  return (
    <div css={pageCss}>
      <div css={leftPanelCss}>
        <img src={Logo} css={logoCss} alt="Minuteful for Wound" />
        <div css={contentCss}>
          <div>
            <Badge intent="warning" withStroke isPill css={badgeWrapperCss}>
              <svg
                width="17"
                height="17"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
              </svg>
              Scheduled Maintenance
            </Badge>
            <Heading as="h3" css={titleCss}>
              Wound Portal temporarily unavailable
            </Heading>
            <div css={bodyTextCss}>
              <Text variant="body1">
                The Wound Portal is currently unavailable while we perform
                scheduled maintenance. This maintenance is expected to take a
                few hours. Your Delivery Manager will let you know as soon as
                the portal is available again.
              </Text>
              <Text variant="body1">
                For urgent issues or questions, please contact support.
              </Text>
            </div>
          </div>
          <Button as="a" href={`mailto:${process.env.CONTACT_US_EMAIL}`}>
            Contact support
          </Button>
        </div>
      </div>
      <div css={rightPanelCss} />
    </div>
  );
}

export default MaintenancePage;
